module.exports = __webpack_public_path__ + "img/FPG-6.b5018110.jpg";